import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { Info } from '../../../../../core/common';
import { IOutageScheduleBody } from '../../../../../core/models';
import { AdminService } from '../../../../../core/services/admin.service';
import { formatDate } from '@angular/common';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
@Component({
  selector: 'app-outage-schedule',
  templateUrl: './outage-schedule.component.html',
  styleUrls: ['./outage-schedule.component.scss']
})
export class OutageScheduleComponent implements OnInit {

  //#region member variable declaration
  outageGridLoading: boolean;
  saveInProcess: boolean;
  outageScheduleGridView: GridDataResult;
  outageScheduleForm: FormGroup;

  public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  
  //#endregion
  constructor(private adminService: AdminService, private formBuilder: FormBuilder,
    private appNotifyService: AppNotifyService,
  ) { }

  ngOnInit() {
    this.outageScheduleForm = this.formBuilder.group({
      outageScheduleId: new FormControl(""),
      description: new FormControl(""),
      startDate: new FormControl(""),
      startDateTime: new FormControl(this.convertTZ(new Date(), 'America/Chicago')),
      endDateTime: new FormControl(this.convertTZ(new Date(), 'America/Chicago')),
      endDate: new FormControl(""),
      startTime: new FormControl(""),
      endTime: new FormControl(""),
      isActive: new FormControl()
    })
    this.loadOutageScheduleGrid();
  }

  //#region Grid data binding
  public loadOutageScheduleGrid(): void {
    //this.outageGridLoading = true;
    this.adminService.getOutageSchedule().subscribe((response) => {
      this.bindOutageScheduleGrid();
      //this.outageGridLoading = false;
    });
  }
  //#endregion

  //#region pagination, sorting,filtering for grid

  public outageScheduleGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'categoryId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindOutageScheduleGrid(): void {
    const data = this.adminService.outageSchedule;
    this.outageScheduleGridView = process(data, this.outageScheduleGridstate);
  }

  public outageScheduleGridSortChange(sort: SortDescriptor[]): void {
    this.outageScheduleGridstate.sort = sort;
    this.bindOutageScheduleGrid();
  }
  public outageScheduleGridPageChange({ skip, take }: PageChangeEvent): void {
    this.outageScheduleGridstate.skip = skip;
    this.outageScheduleGridstate.take = take;
    this.bindOutageScheduleGrid();
  }

  public outageScheduleDataStateChange(state: DataStateChangeEvent): void {
    this.outageScheduleGridstate = state;
    this.bindOutageScheduleGrid();
  }
  //#endregion
  
  //#region Category label and variable declaration
  outageSchedules = {
    descriptionLbl: "Description",
    startDateLbl: "Start Date",
    endDateLbl: "End Date",
    startTimeLbl: "Start Time",
    endTimeLbl: "End Time",
    isActiveLbl: "Status Active",
    actionLbl: "Action",
    isEmptyStartDate: false,
    isEmptyEndDate: false,
    isSubmitted: false,
    todayDate: new Date(),
    isEndDateInValid: false,
    isEndTimeInValid:false
  }
  //#endregion
  
  //#region architecture category dialog operations
  convertTZ(date, tzString) {
  return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
}
  outageScheduleDialog = {
    opened: false,
  }
  toggleOutageScheduleDialog() {
    this.outageScheduleDialog.opened = !this.outageScheduleDialog.opened;
    if (this.outageScheduleDialog.opened == false) {
      this.resetOutageSchedulesForm();
    } else {
      //set isactive true here
      this.outageScheduleForm.controls.isActive.setValue(true);
    }
  }
  //#endregion

  resetOutageSchedulesForm() {
    this.outageSchedules.isSubmitted = false;
    this.outageScheduleForm.reset();
    this.outageSchedules.isEmptyStartDate = false;
    this.outageSchedules.isEmptyEndDate = false;
    this.outageSchedules.isEndDateInValid = false;
    this.outageSchedules.isEndTimeInValid = false;
    this.infoMessage = new Info();
    this.saveInProcess = false;

  }


  public validateOutageSchedulesForm(): boolean {
    let isValid = true;
    const controls = this.outageScheduleForm.controls;
    if (this.outageSchedules.isSubmitted) {
      //if (controls.startDate.value) {
      //  this.outageSchedules.isEmptyStartDate = false;
      //} else {
      //  this.outageSchedules.isEmptyStartDate = true;
      //  isValid = false;
      //}
      //if (controls.endDate.value) {
      //  this.outageSchedules.isEmptyEndDate = false;
      //} else {
      //  this.outageSchedules.isEmptyEndDate = true;
      //  isValid = false;
      //}
      if (controls.startDateTime.value) {
        this.outageSchedules.isEmptyStartDate = false;
      } else {
        this.outageSchedules.isEmptyStartDate = true;
        isValid = false;
      }
      if (controls.endDateTime.value) {
        this.outageSchedules.isEmptyEndDate = false;
      } else {
        this.outageSchedules.isEmptyEndDate = true;
        isValid = false;
      }
      if (controls.startDateTime.value >= controls.endDateTime.value) {
        this.outageSchedules.isEmptyEndDate = true;
        isValid = false;
      } else {
        isValid = true;
      }
    }
    return isValid;
  }
  //Need to implement end time validation here
  //validateTime(startTime, endTime) {
  //  var isValidTime = true;    
  //  if (endTime < startTime) {
  //    isValidTime = false;
  //  }
  //  return isValidTime;
  //}

  saveOutageSchedule() {
    this.outageSchedules.isSubmitted = true;
    if (!this.validateOutageSchedulesForm()) {
      return;
    }
    var controls = this.outageScheduleForm.controls;
    //Checking end date validation here
    //if (controls.startDate.value > controls.endDate.value) {
    //  this.outageSchedules.isEmptyEndDate = true;
    //  this.outageSchedules.isEndDateInValid = true;
    //  return;
    //} else {
    //  this.outageSchedules.isEndDateInValid = false;
    //}
    //if (controls.startTime.value && controls.endDate.value) {
    //  var isValidEndTime = this.validateTime(controls.startTime.value, controls.endDate.value)
    //  if (isValidEndTime == false) {
    //    this.outageSchedules.isEndTimeInValid = true;
    //  } else {
    //    this.outageSchedules.isEndTimeInValid = false;
    //  }
    //}    
    this.inProgressMessage = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    this.saveInProcess = true;
    const body: IOutageScheduleBody = {
      outageScheduleId: controls.outageScheduleId.value,
      outageDescription: controls.description.value,
      startDate: formatDate(controls.startDateTime.value, 'MM/dd/yyyy', 'en'),
      endDate: formatDate(controls.endDateTime.value, 'MM/dd/yyyy', 'en'),
      startTime: formatDate(controls.startDateTime.value,'HH:mm','en'),
      endTime: formatDate(controls.endDateTime.value, 'HH:mm', 'en'),
      isActive: controls.isActive.value,
    }
    this.adminService.saveOutageSchedule(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (response) {
        this.resetOutageSchedulesForm();
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        //this.bindOutageScheduleGrid(); //commenting this because date format is not correct in cache
        this.loadOutageScheduleGrid(); //Need to remove this method once date format issue resolve
      }
      else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }

    })
  }
 

  editOutageSchedule(data) {
    this.outageScheduleDialog.opened = !this.outageScheduleDialog.opened;
    this.outageScheduleForm.controls.outageScheduleId.setValue(data.outageScheduleId);
    var hours = Number(data.startTime.match(/^(\d+)/)[1]);
    var minutes = Number(data.startTime.match(/:(\d+)/)[1]);
    if (data.startTime.includes('AM') && hours === 12) {
      hours = hours - 12;
    }
    if (data.startTime.includes('PM') && hours < 12) {
      hours = hours + 12;
    } 
   //const startTime: Date = new Date(2000, 2, 10, hours, minutes);
    var startHrs = hours + ':' + minutes;
    var tempStartDateTime = data.startDate + ' ' + startHrs;
    var startDateTime = new Date(tempStartDateTime);


    var endhours = Number(data.endTime.match(/^(\d+)/)[1]);
    var endminutes = Number(data.endTime.match(/:(\d+)/)[1]);
    if (data.endTime.includes('AM') && endhours === 12) {
      endhours = endhours - 12;
    }
    if (data.endTime.includes('PM') && endhours < 12) {
      endhours = endhours + 12;
    }
    //const startTime: Date = new Date(2000, 2, 10, hours, minutes);
    var endHrs = endhours + ':' + endminutes;
    var tempEndDateTime = data.endDate + ' ' + endHrs;
    var endDateTime = new Date(tempEndDateTime);
    this.outageScheduleForm.controls.startDateTime.setValue(startDateTime);
    this.outageScheduleForm.controls.endDateTime.setValue(endDateTime);
    //var startDate = new Date(data.startDate);
    //this.outageScheduleForm.controls.startDate.setValue(startDate);
    //var endDate = new Date(data.endDate);
    //this.outageScheduleForm.controls.endDate.setValue(endDate);    
        
    //const startTime: Date = new Date(data.startTime);
     //Need to check date binding with this time
    //this.outageScheduleForm.controls.startTime.setValue(startTime);
    //this.outageScheduleForm.controls.endTime.setValue(data.endTime);
    this.outageScheduleForm.controls.description.setValue(data.outageDescription);
    this.outageScheduleForm.controls.isActive.setValue(data.isActive);
  }

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete outage ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  public RemoveHandler() {
    this.adminService.deleteOutageSchedule(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const outageScheduleId = this.gridItemToRemove.outageScheduleId;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected outage has been removed.");

      if (this.adminService.outageSchedule) {
        //This is a Local Remove
        const index = (this.adminService.outageSchedule).findIndex(r => r.outageScheduleId === outageScheduleId);
        (this.adminService.outageSchedule).splice(index, 1);
        this.bindOutageScheduleGrid();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion

}
